module.exports = __webpack_public_path__ + "static/media/12-photo2.6f294c62.png";